export default __webpack_public_path__ + "eb75438d94d30cc0bb5222c364b338b8.svg";